const sleepingMugicsSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="140.797px" height="179.067px" viewBox="0 0 140.797 179.067" enable-background="new 0 0 140.797 179.067"
	 xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<path fill="#EBEBEB" d="M114.751,98.612c4.402-8.037,6.821-17.648,6.821-28.295c0,0-0.21-57.683-0.516-58.334
				C120.107,4.968,114.379,0,107.243,0C99.43,0,94.054,5.563,93.698,13.233c-0.059,0.35-0.043,0.661-0.043,1.057v57.006
				c0,15.39-8.635,25.871-23.043,25.871c-14.404,0-22.979-10.481-22.979-25.871c0,0-0.229-58.631-0.524-59.272
				C46.175,4.989,40.427,0,33.278,0c-7.709,0-13.536,5.423-14.026,12.934c-0.096,0.433-0.597,0.847-0.597,1.356v56.027
				c0,10.874,2.908,20.662,7.49,28.803C10.001,105.113,0,118.481,0,137.417c0,25.32,18.503,41.65,44.094,41.65h52.797
				c25.588,0,43.906-16.6,43.906-42.188C140.797,118.265,130.695,104.959,114.751,98.612z"/>
			<g>
				<path fill="#FFFFFF" d="M119.824,137.652c0,12.726-10.314,23.038-23.035,23.038H44.035c-12.72,0-23.037-10.313-23.037-23.038
					l0,0c0-12.726,10.317-23.04,23.037-23.04h52.754C109.51,114.612,119.824,124.927,119.824,137.652L119.824,137.652z"/>
			</g>
		</g>
		<g>
			<path fill="#8D8D8D" d="M104.511,128.922c-1.6-0.712-3.557,0-4.268,1.6c-1.244,2.668-3.912,4.446-6.934,4.446
				c-3.023,0-5.691-1.778-6.935-4.446c-0.712-1.6-2.667-2.312-4.267-1.6c-1.602,0.711-2.313,2.666-1.602,4.268
				c2.135,5.156,7.111,8.356,12.803,8.356c5.512,0,10.489-3.2,12.802-8.356C106.999,131.41,106.111,129.633,104.511,128.922z"/>
			<path fill="#8D8D8D" d="M59.157,133.189c0.889-1.602,0.177-3.557-1.422-4.268c-1.602-0.891-3.559-0.178-4.269,1.422
				c-1.245,2.489-3.913,4.09-6.579,4.09c-2.668,0-5.334-1.601-6.578-4.09c-0.89-1.6-2.668-2.134-4.268-1.422
				c-1.601,0.889-2.134,2.666-1.423,4.268c2.312,4.622,7.112,7.645,12.269,7.645S56.668,137.989,59.157,133.189z"/>
		</g>
		<path fill="#8D8D8D" d="M107.466,79.819h10.063l-2.406,1.968l-7.656,6.563l-2.188,1.969c-1.095,0.875-1.313,2.407-0.877,3.72
			c0.439,1.313,1.75,2.188,3.064,2.188h13.563h5.25c1.094,0,2.188-0.657,2.844-1.533c0.219-0.437,0.438-1.093,0.438-1.75
			c0-1.75-1.531-3.28-3.281-3.28h-0.219h-9.844l5.25-4.376l7-6.124c1.094-0.876,1.313-2.407,0.875-3.72
			c-0.438-1.313-1.75-2.188-3.063-2.188h-18.813c-1.75,0-3.282,1.531-3.282,3.281S105.496,79.819,107.466,79.819z"/>
		<path fill="#8D8D8D" d="M132.841,63.85h-3.063l4.813-4.156c0.656-0.875,1.094-1.969,0.656-3.063
			c-0.438-1.094-1.313-1.749-2.406-1.749h-10.282c-1.53,0-2.624,1.094-2.624,2.624c0,1.532,1.094,2.625,2.624,2.625h3.063
			l-4.813,4.157c-0.874,0.656-1.093,1.969-0.655,2.844l0,0c0.438,0.876,1.313,1.531,2.405,1.531h8.97h1.313
			c1.531,0,2.625-1.094,2.625-2.625C135.466,64.943,134.153,63.85,132.841,63.85z"/>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids" display="none">
</g>
</svg>

`;

export default sleepingMugicsSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/sleepingMugicsSVG.js